import { Entity, Region } from './enums';

export interface ProvisionData {
  username_b64: string;
  password: string;
  source?: string;
  signup?: ProvisionSignupData;
  device?: ProvisionDeviceData;
  sso?: ProvisionSSOData;
  existingUserForCncId?: number;
  businessTeams?: boolean;
  paidToCNC?: boolean;
  saltData?: string;
  isLegacyToCNC?: boolean;
  upgradProductName?: string;
  chargebee_customer_id?: string;
  region?: Region;
  entity?: Entity;
  from_email?: number;
}

export interface ProvisionSignupData {
  enc_sync_root_name: string;
  first_name_b64?: string;
  last_name_b64?: string;
  enc_password: string;
  enc_share_key: string;
  enc_meta_key: string;
  enc_priv_key: string;
  pub_key: string;
  referral_code?: string;
  signup_ref?: string;
  invite_cachekey?: string;
  hubspotutk?: string;
  password_hint?: string;
  signup_ref_b64?: string;
  enc_pass_meta?: string;
  enc_pass_priv?: string;
  enable_reset?: number;
  is_trial?: boolean;
  utm_params?: string;
  utm_params_source?: string;
  utm_params_medium?: string;
  utm_params_keyword?: string;
  utm_params_gclid?: string;
  page_uri?: string;
  page_name?: string;
  page_id?: string;
}

export interface ProvisionDeviceData {
  devicetype_id: number;
  device_name_b64: string;
  version: string;
}

export interface ProvisionSSOData {
  sso_key: string;
  sso_val: string;
  sso_redirect?: string;
}

export enum WorkerCmd {
  ERROR,
  LOG,
  RUN,
  COMPLETE,
}

export enum PaymentSuccessType {
  UPGRADE = 'upgrade',
  REACTIVATION = 'reactivation',
  PURCHASE_SEATS = 'purchase_seats',
}

export interface ChargebeeProvisionData {
  email: string;
  customer_id: string;
  billing_address: {
    company: string;
    first_name: string;
    last_name: string;
    country: string;
    state: string;
    city: string;
    [k: string]: any;
  };
  item_price_id: string;
  plan_name: string;
  quantity: number;
  billing_period_unit: string;
  currency_code: string;
  is_trial: boolean;
  pricing_model: string;
  product_price: number;
  sub_total: number;
  discount: number;
  tax: number;
  total: number;
  coupons: any;
  subscription_id: string;
  [k: string]: any;
}
